import { render, staticRenderFns } from "./UserOptionsDropdown.vue?vue&type=template&id=099ace08&"
import script from "./UserOptionsDropdown.vue?vue&type=script&lang=ts&"
export * from "./UserOptionsDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports